import React from "react";
import "./Pricing.css";
import Card from "../Components/Card";
// import { Link } from "react-router-dom";


const Pricing = () => {
  return (
    <>
    <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">Pricing</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>
    <h1 className="text-center">Affordable, Accelerated, Organic
      <br/> Instagram Growth.</h1>
    <p className="pricing-p text-center">No bots. No fake users. Guaranteed results or it’s free!</p>
    <Card />
    
    </>

  );
};

export default Pricing;
